import { EpimsBaseEntityDto } from './epim-base.dto';
export class CofOStatusDto extends EpimsBaseEntityDto {
  CofOStatusName: string;
  SubscriptionUserId: string;
  Version: number;
  COfODate: Date;
}
